<template>
    <div class='HowPageContainer' ref='how_page'>
        <modals-container/>

        <div class='PageHeader'>
            <div class='PageHeaderRollsRoyceLogo'></div>
            <div class='PageHeaderTitleContainer'>Tools</div>
            <div class='PageHeaderButtonContainer'>
                <button class='AcronymsButton' :class="{ AcronymsOnState: acronymsState }" @click="showAcronyms"></button>

                <router-link :to="{ name: 'HomePage' }">
                    <button class='NavBackButton'></button>
                </router-link>
            </div>
        </div>

        <div class='ToolsContentContainer' ref='how_image'>

          <div class="toolsMain">
            <span class="pageTitle"> Overview </span>
            <span class="summaryText">
              This section allows you to download tools for specific processes. <br> It also provides a brief summary of how to use the tools.

              <p>For further information contact your Rolls-Royce Purchase representative.</p>
            </span>
            <div class="vidContainer">
              <VidComponent
                  :video-prop="{url: 'assets/animations/tools/Tools.mp4', poster: 'assets/images/tools/tools-poster.jpg', buttons:
                  [{name: 'Reference PFMEA ', time: 9},
                  {name: 'Foundation Control Plan', time: 55},
                  {name: 'Benchmark Assessment Tool ', time: 88}], classes:'container-override'}"></VidComponent>
            </div>
<!--            <div class="btnContainer">-->
<!--              <div class="btn-outline-primary" > PFMEA and how to use it </div>-->
<!--              <div class="btn-outline-primary" > Control Plan and how to use it </div>-->
<!--              <div class="btn-outline-primary" > SPMA and how to use it </div>-->

<!--            </div>-->
          </div>
          <div class="resources" >
            <ResourcesComponent></ResourcesComponent>
          </div>

        </div>


    </div>
</template>

<script>
  import ResourcesComponent from "../ResourcesComponent.vue";
  import AcronymsModal from "@/components/modals/AcronymsModal";
  import VidComponent from "@/components/VidComponent";
export default {

    data () {
        return {
          acronymsState: false,
        }
    },

    created() {

    },

    watch: {

    },

    methods: {
      showAcronyms() {
        // Open Acronyms Modal 'LightOut' Box
        this.$modal.show(AcronymsModal, {}, {
          width: "100%",
          height: "auto"
        },{
          'before-close': () => { this.acronymsState = !this.acronymsState }
        });

        this.acronymsState = !this.acronymsState
      },
    },
  components:{
    ResourcesComponent,
    VidComponent
  }
    
}
</script>
<style scoped>
.ToolsContentContainer{
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  font-family: RRPioneer;
}
.toolsMain{
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: 60px;
  width: 100%;
  flex: 0 0 60%;
}
.pageTitle{
  color: #10069F;
  font-size: 28px;
  margin: 0 0 0 45px;
}
.summaryText{
  margin: 25px 0 0 45px;
  color: #666666;
  font-size: 22px;
}
.resources{
  height: 100%;
  width: 100%;
  background: #EFEFF4;
}
.vidContainer{
  height: 593px;
  max-width: 1054px;
  border: 1px solid #707070;
  margin: 0 0 0 45px;
  padding: 5px;
}
.btnContainer{
  width: 1054px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 28px 0 0 45px;
}
.btn-outline-primary{
  margin-right: 0;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>